module.exports = __webpack_public_path__ + "static/img/fl23_2.eda2815.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fl20210204/fl23_2.png
// module id = 04Fs
// module chunks = 0